import { action, type Action } from 'easy-peasy';
import { CollapseType } from '@meitu/saas-editor-ui';
import { TabEnum } from '@/types';

export interface IElementCollapseModel {
    /**
     * 当前元素内tab
     */
    elementCurTab: TabEnum;

    /**
     * 来源信息
     */
    from: CollapseType | null;

    /**
     * 设置当前元素内tab
     */
    setElementCurTab: Action<IElementCollapseModel, TabEnum>;

    /**
     * 设置来源信息
     */
    setFrom: Action<IElementCollapseModel, CollapseType | null>;

    /**
     * 是否显示二级返回标题（进入专题列表需要展示二级返回标题）
     */
    showSubBackTitle: boolean;

    /**
     * 设置是否显示二级返回标题
     */
    setShowSubBackTitle: Action<IElementCollapseModel, boolean>;
}

export const elementCollapseModel: IElementCollapseModel = {
    elementCurTab: TabEnum.MATERIAL_MENU,

    from: null,

    showSubBackTitle: false,

    setShowSubBackTitle: action((state, payload) => {
        state.showSubBackTitle = payload;
    }),

    setElementCurTab: action((state, payload) => {
        state.elementCurTab = payload;
    }),

    setFrom: action((state, payload) => {
        state.from = payload;
    }),
};
